import * as Sentry from "@sentry/nextjs";
import type { AxiosError } from "axios";
import "navigator.locks";
import axios from "axios";
import Cookies from "js-cookie";

import { config } from "shared/data";

export const logout = () => {
  const url = new URL(`${config.account.scmpAccountHost}/logout`);
  url.searchParams.set("destination", encodeURIComponent(location.href));
  location.href = url.toString();
};

export const refreshToken = async () => {
  const url = `${config.account.scmpAccountHost}/refreshToken`;
  const postPromise = async () => {
    try {
      return await axios.post(url, null, { withCredentials: true });
    } catch (error) {
      const { response } = error as Required<AxiosError<{ code: number; message: string }>>;
      const scmpAtExp = Cookies.get("scmp_at_exp");
      const scmpRtSub = Cookies.get("scmp_rt_sub");
      Sentry.captureException(error, {
        extra: { response, scmpAtExp, scmpRtSub },
      });
      if (response && response.data?.message === "missing scmp_at or scmp_rt") {
        logout();
      }
    }
  };
  // Ensure no other refresh token will be called
  return navigator.locks.request("refreshToken", { ifAvailable: true }, async lock => {
    if (!lock) return;
    return await postPromise();
  });
};
